<script setup>
import { differenceInCalendarDays } from 'date-fns';
// eslint-disable-next-line import/extensions
import { ru } from 'date-fns/locale/index.js';
import { computed } from 'vue';

const formattedDate = computed(() => {
  const day = differenceInCalendarDays(
    new Date(),
    new Date(2022, 1, 23, 0, 0, 0)
  );
  return { day };
});

const localizedDate = computed(() => {
  const localizedDay = ru.localize.ordinalNumber(
    formattedDate.value.day,
    'week'
  );
  return { localizedDay };
});
</script>

<template>
  <div class="counter">
    <div class="counter__pulse"></div>
    <div class="counter__date">{{ localizedDate.localizedDay }} день войны</div>
  </div>
</template>
;

<style lang="postcss" scoped>
.counter {
  display: flex;
  align-items: center;
  flex-direction: row;
  margin-top: 10px;
  z-index: 2;

  &__date {
    font-size: calc(15px + 0.3906vw);
    line-height: calc(18px + 0.3906vw);
    margin-left: 4px;
    color: #fff;
  }

  &__pulse {
    position: relative;
    display: inline-block;
    width: 10px;
    height: 10px;
    animation: pulsate 1.3s ease-out;
    animation-iteration-count: infinite;
    text-align: center;
    opacity: 0;
    border-radius: 50%;
    background: #dc343c;
  }

  @keyframes pulsate {
    0% {
      transform: scale(0.1, 0.1);
      opacity: 0;
    }

    50% {
      opacity: 1;
    }

    100% {
      transform: scale(1.2, 1.2);
      opacity: 0;
    }
  }
}
</style>
